var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 30",
    style: {
      enableBackground: "new 0 0 24 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0000B5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_file-document-outline",
    className: "st0",
    d: "M3,0C1.3,0,0,1.3,0,3v24c0,1.7,1.3,3,3,3l0,0h18c1.7,0,3-1.3,3-3l0,0V9l-9-9 H3 M3,3h10.5v7.5H21V27H3V3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_format-list-checks",
    className: "st0",
    d: "M6.5,13.3h3.9v4.1H6.5V13.3 M7.8,14.8v1h1.3v-1H7.8 M11.7,14.8h6.4v1.5h-6.4 L11.7,14.8 M11.7,20.9h6.4v1.5h-6.4V20.9 M7.8,24.7L5.6,22l0.9-1.1l1.3,1.6l3-3.5l0.9,1.1L7.8,24.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkorder);
export default __webpack_public_path__ + "static/media/workorder.50cae5b57fc897810ad482ead95fd136.svg";
export { ForwardRef as ReactComponent };